module.exports = __webpack_public_path__ + "static/media/product.273b4c95.jpg";